export default __webpack_public_path__ + "static/media/logo.936d8e22.svg";